import React from 'react';

export const FooterCopyright = () => {

  return (
    <footer className="footer-copyright">
      <p>Copyright © 2020, Developed by Yampi</p>
    </footer>
  )
}